export default "__VITE_ASSET__tFFHKPEk__"